module.exports = __webpack_public_path__ + "static/media/YM59_3.52ce706d.jpg";